import React, { lazy, Suspense, useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router";
import ReactGA from "react-ga4";

import Spinner from "./components/Spinner";

const Admin = lazy(() => import("./pages/Admin"));
const UserPortal = lazy(() => import("./pages/UserPortal"));
const MagicLink = lazy(() => import("./pages/MagicLink"));
const EmpAuth = lazy(() => import("./pages/EmpAuth"));
const ForgotPassword = lazy(
  () => import("./components/AuthGate/forgotPassword"),
);
const UpdatePassword = lazy(() => import("./pages/UserPortal/UpdatePassword"));
const PrivacyPolicy = lazy(() => import("./pages/UserPortal/PrivacyPolicy"));
const Maintenance = lazy(() => import("./pages/Maintenance"));

import "./static/styles/reset.css";

const PageTracker = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);

    ReactGA.send({
      hitType: "pageview",
      page: location.pathname + location.search,
    });
  }, [location]);

  return null;
};

export const isMaintenanceMode = false;

const App = () => {
  useEffect(() => {
    setTimeout(() => {
      ReactGA.initialize("UA-76124910-23");
    }, 0);
  }, []);

  return (
    <>
      <BrowserRouter>
        <PageTracker />
        {isMaintenanceMode ? (
          <Routes>
            <Route path="*" element={<Maintenance />} />
          </Routes>
        ) : (
          <Suspense fallback={<Spinner />}>
            <Routes>
              <Route path="/admin/*" element={<Admin />} />
              <Route path="/magiclink/:token" element={<MagicLink />} />
              <Route path="/empauth/*" element={<EmpAuth />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/update-password" element={<UpdatePassword />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />

              <Route path="/*" element={<UserPortal />} />
            </Routes>
          </Suspense>
        )}
      </BrowserRouter>
    </>
  );
};

export default App;
